'use client';

import React from 'react';
import { Box, Typography, Grid, Card, CardContent, CardActions, Button, Container } from '@mui/material';
import Link from 'next/link';
import { Icon } from '@iconify/react';
import { useSession } from 'next-auth/react';
import { PublicPageLayout } from '@letsgo/PublicPageLayout';
import { freeTools } from '../../lib/toolsData';

export default function ToolsIndexPage() {
  const { data: session } = useSession();
  const toolsToShow = session?.user ? freeTools : freeTools.filter((t) => t.id !== 'my-content');
  return (
    <PublicPageLayout>
      <Container maxWidth="lg" component="main" id="main-content" sx={{ py: { xs: 4, md: 6 }, px: { xs: 2, sm: 3 } }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight={700} color="text.primary">
          Free tools
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 720 }}>
          Calculators, research helpers, and templates you can use without signing up. Sign in for tools that use your connected accounts.
        </Typography>
        <Grid container spacing={3}>
          {toolsToShow.map((tool) => (
            <Grid item xs={12} sm={6} md={4} key={tool.id}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'center', flexGrow: 1 }}>
                  <Box sx={{ width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', color: tool.color }}>
                    {tool.icon ? <Icon icon={tool.icon} width={32} height={32} /> : null}
                  </Box>
                  <Box>
                    <Typography variant="h6">{tool.label}</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      {tool.description}
                    </Typography>
                  </Box>
                </CardContent>
                <CardActions sx={{ pt: 0, px: 2, pb: 2 }}>
                  <Button component={Link} href={tool.path} size="small" variant="outlined">
                    Open
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </PublicPageLayout>
  );
}
